module.exports = __webpack_public_path__ + "img/z2.0d5a83b4.jpg";